import React from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import Survey from "./pages/Survey";
import ThankYou from "./pages/ThankYou";
import Login from "./pages/Login";
import Painel from "./pages/Painel";
import YearSelection from "./pages/YearSelection";
import AdminPanel from "./pages/AdminPanel";
import Auditoria from "./pages/Auditoria";
import TokensPage from "./pages/TokensPage"; // Importando a nova página
import { AuthProvider, useAuth } from "./context/AuthContext";

// import css
import "./assets/css/remixicon.css";
import './styles/global.css'; // Importando os estilos globais



function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Survey />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/login" element={<Login />} />
        <Route 
          path="/year-selection" 
          element={
            <RequireAuth>
              <YearSelection />
            </RequireAuth>
          } 
        />
        <Route 
          path="/painel" 
          element={
            <RequireAuth>
              <Painel />
            </RequireAuth>
          } 
        />
        <Route 
          path="/painel/:year" 
          element={
            <RequireAuth>
              <Painel />
            </RequireAuth>
          } 
        />
        <Route 
          path="/admin" 
          element={
            <RequireAuth>
              <AdminPanel />
            </RequireAuth>
          } 
        />
        <Route 
          path="/auditoria" 
          element={
            <RequireAuth>
              <Auditoria />
            </RequireAuth>
          } 
        />
        <Route 
          path="/tokens" 
          element={
            <RequireAuth>
              <TokensPage />
            </RequireAuth>
          } 
        />
      </Routes>
    </AuthProvider>
  );
}

// Componente para proteger rotas que necessitam de autenticação
function RequireAuth({ children }) {
  const { currentUser } = useAuth();

  return currentUser ? children : <Navigate to="/login" />;
}

export default App;
